<template>
  <div>
    <el-form size="small">
      <el-form-item>
        <el-date-picker value-format="yyyy-MM-dd" :clearable="false" style="width:160px;margin-right:8px" v-model="startTime" type="date" placeholder="选择日期" />
        <span>日</span>
        <span style="color:rgba(0,0,0,.65)">（默认今天）</span>
      </el-form-item>
      <el-form-item>
        <el-select v-model="typeValue" style="display:inlin-block;width:76px">
          <el-option label="往后" :value="1" />
          <el-option label="往前" :value="-1" />
        </el-select>
        <el-input v-model.number="daysValue" style="display:inlin-block;width:80px" />
        <el-select v-model="timeType" style="display:inlin-block;width:76px">
          <el-option label="天" :value="1" />
          <el-option label="星期" :value="2" />
          <el-option label="月" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDiffValues">计算日期</el-button>
        <span style="color:rgba(0,0,0,.85);padding-left:16px">
          是：<span v-if="diffDaysValue">{{ $common.timesToTime(diffDaysValue) }} {{ weekDays }}</span>
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'DateCalculation',
  data() {
    return {
      diffDaysValue: '',
      weekDays: '',
      startTime: '',
      timeValues: [],
      daysValue: 100,
      typeValue: 1,
      timeType: 1,
    }
  },
  created() {
    this.startTime = this.$common.timesToTime(new Date())
  },
  methods: {
    getDiffValues() {
      if (!this.daysValue) {
        this.$message.error('请输入需要推算的天数')
        return
      }
      let daystimestamp = new Date(`${this.startTime} 00:00:00`).getTime()
      let diffNum = this.daysValue * this.typeValue
      let year = new Date(daystimestamp).getFullYear()
      let month = new Date(daystimestamp).getMonth()
      let date = new Date(daystimestamp).getDate()
      let weekArr = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ]
      if (this.timeType == 1)
        this.diffDaysValue = new Date(
          daystimestamp + diffNum * 24 * 3600 * 1000
        )
      if (this.timeType == 2)
        this.diffDaysValue = new Date(
          daystimestamp + diffNum * 24 * 3600 * 1000 * 7
        )
      if (this.timeType == 3)
        this.diffDaysValue = new Date(year, month + diffNum, date)
      this.weekDays = weekArr[this.diffDaysValue.getDay()]
    },
  },
}
</script>
<style scoped>
.diff-value {
  width: 470px;
  font-size: 16px;
  color: #303133;
}
</style>
